import React, { Component } from 'react';
import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import { SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPAdminAutomaticOrders from 'client/components/UPAdminAutomaticOrders/UPAdminAutomaticOrders';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS)
@withScrollToTop
class UtilityProfitAutomaticOrdersPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Automatic Orders | Utility Profit',
  });

  render() {
    return (
      <SrPartnerPageV2
        navbarTitle="Automatic Orders"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <UPAdminAutomaticOrders />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAutomaticOrdersPage;
